import { useEffect, useReducer } from "react";
import { api } from "../lib/api";

const initialState = { data: null, loading: true, error: "" };

function reducer(state, action) {
    switch (action.type) {
        case "start":   return { data: state.data, loading: true, error: "" };
        case "success": return { data: action.payload, loading: false, error: "" };
        case "failure": return { data: state.data, loading: false, error: action.payload };
        default:        return state;
    }
}

// Generic GET-fetcher. Re-runs when `path` changes. Pass a falsy path to skip
// fetching (useful when the parent conditionally wants data). Cancels in-flight
// on unmount.
export function useApiResource(path) {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!path) {
            dispatch({ type: "success", payload: null });
            return;
        }
        let cancel = false;
        dispatch({ type: "start" });
        api.get(path)
            .then((r) => { if (!cancel) dispatch({ type: "success", payload: r.data }); })
            .catch((e) => { if (!cancel) dispatch({ type: "failure", payload: e.response?.data?.detail || e.message }); });
        return () => { cancel = true; };
    }, [path]);

    return state;
}
